// src/pages/admin/AdDelete.jsx
import React from 'react';

export default function AdDelete() {
  return (
    <div>
      <h2>Ad Delete</h2>
      <p>Remove old or expired advertisements from the platform.</p>
    </div>
  );
}
